import { render, staticRenderFns } from "./SettingUserData.vue?vue&type=template&id=1f3af235&scoped=true&"
import script from "./SettingUserData.vue?vue&type=script&lang=js&"
export * from "./SettingUserData.vue?vue&type=script&lang=js&"
import style0 from "./SettingUserData.vue?vue&type=style&index=0&id=1f3af235&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3af235",
  null
  
)

export default component.exports